import React from 'react';

import { PageTitle } from '../../Text';

export default () => (
  <div className="primary-content">
    <PageTitle>
      Mailing Address
    </PageTitle>
    <p>
      Please select the Card mailing address from the below options:
    </p>
  </div>
);
